<template>
    <div>
        <div class="input-group">
            <label for="turna-api-key">Turna API Key:</label>
            <input id="turna-api-key" type="text" v-model="APIKey" placeholder="Turna API Key girin" />
        </div>
        <div class="input-group">
            <label for="turna-api-url">Turna API URL:</label>
            <input id="turna-api-url" type="text" v-model="APIURL" placeholder="Turna API URL girin" />
        </div>
        <div class="input-group">
            <label for="turna-agency-code">Acente Kodu</label>
            <v-autocomplete ref="acenteAuto" :items="airlineList" v-model="AgencyCode"
                :label="$t('Agency-Code-Select')" item-text="Title" item-value="HavaYoluKodu"
                :rules="[v => !!v || 'Bu alan zorunludur']" outline clearable />
        </div>
        <v-btn color="primary" class="mt-4" @click="saveProviderConfig">
            Kaydet
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "TurnaProvider",
    props: {
        providerData: {
            type: Object,
            default: () => ({})
        },
        airlineList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            APIKey: "",
            APIURL: "",
            AgencyCode: "",
        }
    },
    watch: {
        // providerData her değiştiğinde içindeki değerleri inputlara eşitler
        providerData: {
            handler(newValue) {
                this.fillForm(newValue);
            },
            deep: true // Objenin içindeki değişiklikleri de yakalamak için
        }
    },
    mounted() {
        // Bileşen ilk açıldığında veri zaten yüklü gelmişse formu doldurur
        this.fillForm(this.providerData);
    },
    methods: {
        fillForm(data) {
            console.log(data);
            if (data && Object.keys(data).length > 0) {
                // Servisinizden dönen API Key ve URL parametre isimlerine göre eşitleyin.
                // Örn: data.ServiceUsername ya da data.apiKey hangisi geliyorsa onu yazmalısınız.
                this.APIKey = data.ServiceUsername || data.apiKey || "";
                this.APIURL = data.Address || data.url || "";
                this.AgencyCode = data.OfficeId || data.acenteKodu || "";
            }
        },
        saveProviderConfig() {
            // providerData doluysa 'edit', boşsa 'add' kabul edilir
            const type = (this.providerData && Object.keys(this.providerData).length > 0) ? 'edit' : 'add';

            if (!this.APIKey || !this.APIURL)
                return this.$toast.error("Lütfen tüm alanları doldurun.");

            const config = {
                ServiceUsername: this.APIKey,
                Address: this.APIURL,
                OfficeId: this.AgencyCode,
            }
            console.log(config,"config")
            this.$emit("save", config, type);
        },
    }
}
</script>

<style scoped>
div {
    font-family: 'Roboto', sans-serif;
}

.input-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.input-group label {
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
    font-size: 14px;
}

.input-group input {
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.input-group input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.input-group input::placeholder {
    color: #999;
}

.mt-4 {
    margin-top: 16px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}
</style>